import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MapHelperService } from "../../map-helper.service";
import mapboxgl from 'mapbox-gl';

@Injectable({
  providedIn: "root",
})
export class InfoBoxMapService {

  public isInfoBoxActive: boolean = false;

  // variables para click en el mapa
  showStreetViewInfoBox = false;
  public infoBoxClick = new BehaviorSubject<{ lat: number, lng: number} | null>(null);
  infoBoxClick$ = this.infoBoxClick.asObservable();
  public mapClickMarker!: mapboxgl.Marker;
  public infoBoxDeactivated = new Subject<void>();

  constructor(
    private mapHelperService: MapHelperService,
    ) {
  }

  loadInfoBox(){
    // this.mapHelperService._map.on('load', (e) => {
      //marcador en click
      this.mapHelperService.addEventOnMapClick((event) => {
        if (this.mapHelperService.isPointPickingActive) {
          return;
        }
        if (this.isInfoBoxActive) {
          const { lng, lat } = event.lngLat;
      
        // evitar traslape de click
          const features = this.mapHelperService._map.queryRenderedFeatures(event.point);
          const hasSymbolLayer = features.some( (feature) => this.mapHelperService._map.getLayer(feature.layer.id)?.type === "symbol" );
      
          if (hasSymbolLayer) {
            return;
          }
      
          if (this.mapClickMarker) {
            this.mapClickMarker.remove();
          }

          this.mapClickMarker = new mapboxgl.Marker({ color: "red" }).setLngLat([lng, lat]).addTo(this.mapHelperService._map);

          // Emitir la nueva ubicación
          this.infoBoxClick.next({ lat, lng });
        }
      });
    // });
  }
  
}
